import React, { Component } from "react";
import { NavItem, Nav } from "react-bootstrap";

class HeaderLinks extends Component {
  render() {
    // const notification = (
    //   <div>
    //     <i className="fa fa-globe" />
    //     <b className="caret" />
    //     <span className="notification">5</span>
    //     <p className="hidden-lg hidden-md">Notification</p>
    //   </div>
    // );
    return (
      <div>
        <Nav pullRight>
          <NavItem eventKey={1} href="#">
            Rejestracja
          </NavItem>
          {this.props.userData ? (
            <NavItem eventKey={3} href="#" onClick={this.props.logout}>
              Wyloguj
            </NavItem>
          ) : null}
        </Nav>
      </div>
    );
  }
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx